import { Component, input, output } from '@angular/core';
import { FlexibleStartDateSelectorFieldComponent } from '@lx/quote-tool/lite/shared/ui/components';
import { CalendarConfig } from '@lx/shared/ui/calendar-field';

/**
 * Start Date Selector Component
 *
 * Displays a flexible calendar that allows users to:
 * - Select a start date for their course
 * - View the calculated end date
 *
 * This component is presentation-only and delegates all logic to the parent.
 */
@Component({
  standalone: true,
  selector: 'lx-start-date-selector',
  templateUrl: './start-date-selector.component.html',
  styleUrls: ['./start-date-selector.component.scss'],
  imports: [FlexibleStartDateSelectorFieldComponent],
})
export class StartDateSelectorComponent {
  // Inputs
  readonly selectedStartDate = input<string | undefined>(undefined);
  readonly selectedEndDate = input<string | undefined>(undefined);
  readonly calendarConfig = input<CalendarConfig | undefined>(undefined);

  // Outputs
  readonly startDateSelected = output<string>();

  /**
   * Handles start date changes from date selector
   */
  protected onSelectStartDate(selectedStartDate: string): void {
    if (selectedStartDate) {
      this.startDateSelected.emit(selectedStartDate);
    }
  }
}
